module.exports = __webpack_public_path__ + "static/brewingtrivia-0d51cece72a452f256aab900a85b1d2b.jpg";